import { armorTokenColumn } from "../resource/armor-token-column";
import { NeededColumn } from "./needed-column";

export const armorTokenNeededColumn = new NeededColumn(
  "dcf15a0b-d935-4196-8ee0-c1a08ba431ce",
  armorTokenColumn,
  "AT Needed"
)
